import { ObservablePropType } from "../ObservablePropType";
class TEXT extends ObservablePropType {
  element = () => `<vs-text></vs-input>`;
  parse(value) {
    return value != null ? value.toString() : null;
  }
  constructorName = "TEXT";
}

export default TEXT;
